import 'slick-carousel'

document.addEventListener('turbolinks:load', () => {
  $('.slick-center').slick({
    centerMode: true,
    centerPadding: '60px',
    slidesToShow: 1,
    autoplay: true
  })
})